import { render } from "./Refunds.vue?vue&type=template&id=51c51bce"
import script from "./Refunds.vue?vue&type=script&lang=js"
export * from "./Refunds.vue?vue&type=script&lang=js"
script.render = render

export default script